// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"2822ff33","453":"e2ccff15","625":"9806c0c4","987":"e9268871"}[chunkId] + ".chunk.js";
};